import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { OnWikiRecommendationsModule } from '../OnWikiRecommendationsModule';
const renderOnMobile = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const reactRoot = document.createElement('div');
    const infobox = document.querySelector('.portable-infobox-wrapper');
    if (!infobox) {
        return null;
    }
    reactRoot.classList.add('render-wiki-recommendations');
    infobox.after(reactRoot);
    ReactDOM.render(React.createElement(OnWikiRecommendationsModule, buildModuleProps(moduleConfig, {})), reactRoot);
    return reactRoot;
});
export default renderOnMobile;
